import { render, staticRenderFns } from "./mobApplication-value-SupplierEvaluationSystem.vue?vue&type=template&id=5916e2b2&scoped=true"
import script from "./mobApplication-value-SupplierEvaluationSystem.vue?vue&type=script&lang=js"
export * from "./mobApplication-value-SupplierEvaluationSystem.vue?vue&type=script&lang=js"
import style0 from "./mobApplication-value-SupplierEvaluationSystem.vue?vue&type=style&index=0&id=5916e2b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916e2b2",
  null
  
)

export default component.exports